import React, {ReactElement, ReactNode} from 'react';
import Header from '../Header/Header';
import Footer from '../../Footer/Footer';
import LayoutSection from '../LayoutSection/LayoutSection';
import {SidebarVariant} from '../LayoutSection/LayoutSection.types';

interface Props {
  advantages?: string[];
  children: ReactNode;
  hideAdvantages?: boolean;
  sideBarBottomComponent?: ReactNode;
  showFooter?: boolean;
}

function FormLayout({
  advantages,
  children,
  hideAdvantages,
  showFooter = true,
  sideBarBottomComponent,
}: Props): ReactElement {
  return (
    <>
      <Header focusMode />
      <LayoutSection
        sidebar={{
          advantages,
          hideAdvantages,
          sideBarBottomComponent,
          sidebarVariant: SidebarVariant.DARK,
        }}
      >
        {children}
      </LayoutSection>
      {showFooter && <Footer />}
    </>
  );
}

export default FormLayout;
